import makeStyles from '@mui/styles/makeStyles';
import React, { ReactElement } from "react";
import { IScriptElement, ScriptTypes } from "../script/parseScript";
import { FragmentStyle, IHighlightOptions, ScriptTextRender } from "./ScriptTextRenderer";

const useStyle = makeStyles(theme => ({
    line: {
        fontFamily: 'inherit',
    }
}));

export interface IValues
{
    value: string
}

export interface IStyleTag
{
    offset: number
    details: {
        style: FragmentStyle
        tooltip?: string
        suggestions?: IValues[]
        offset?: number
        length?: number
        rule?: string
        context?: string
    }
    type: "begin" | "end"
}

export interface IActiveTag
{
    tooltip: string
    suggestions?: IValues[]
    offset: number
    length: number
    rule: string
    context: string
}

export type ActiveTags = {
    comment?: IActiveTag
    commentHighlight?: IActiveTag
    grammar?: IActiveTag
    search?: IActiveTag
    spelling?: IActiveTag
};

export type Renderer = (element: IScriptElement, key: string, index: number, activeTags: ActiveTags,
                        textRenderer: ScriptTextRender) => ReactElement | null;
export type ScriptTypeRenderers = { [key in ScriptTypes]: Renderer };

interface Props
{
    classes: { [key in FragmentStyle]: string }
    state: string
    renderers: ScriptTypeRenderers
    text: string
    content: IScriptElement[]
    onClickFragment: (activeTags: ActiveTags) => ((event: React.MouseEvent<HTMLElement>) => void) | undefined
    highlightOptions: IHighlightOptions
}

export default function ScriptRender({ classes, state, text, renderers, content, highlightOptions, onClickFragment }: Props)
{
    const defaultClasses = useStyle();
    const textRenderer: ScriptTextRender = new ScriptTextRender(state, defaultClasses.line, classes, onClickFragment, text, highlightOptions);

    return <>{content.map((line, index) =>
    {
        const styles: ActiveTags = {};

        if (renderers[line.type])
        {
            return renderers[line.type](line, state, index, styles, textRenderer);
        }
        return null;
    })}</>;
}